import GeoJsonObject from 'src/services/geoJson/GeoJsonObject';

export default class GeoJsonLayer extends GeoJsonObject {}
